module.exports = __webpack_public_path__ + "img/lb2.a999eac4.png";